// src/app/slices/lightSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { deleteAccessory } from './actions';
import { ILight, ILightParams, AccessoryState } from '../models';

const initialState: AccessoryState<ILight, ILightParams> = {
  accessories: {},
  params: null,
};

const lightSlice = createSlice({
  name: 'light',
  initialState,
  reducers: {
    setLight: (state, action: PayloadAction<ILight>) => {
      if (!state.accessories[action.payload.section_id])
        state.accessories[action.payload.section_id] = {};
      state.accessories[action.payload.section_id][action.payload.id] =
        action.payload;
    },
    setLightParams: (state, action: PayloadAction<ILightParams>) => {
      state.params = action.payload;
    },
    deleteLight: deleteAccessory,
  },
});

export const { setLight, setLightParams, deleteLight } = lightSlice.actions;

export default lightSlice.reducer;
